<div class="auth-container">
  <div class="auth-sub-container">

    <img src="logo.png" alt="Wide & Heavy" class="logo" matTooltip="Wide & Heavy" />

    <h1 class="title">Welcome back</h1>

    @if (!isUserLogInEnabled() && !loadingSettings()) {
    <div class="red-container">
      Login is currently disabled.
      Try again later.
    </div>
    }

    <form [formGroup]="form" (ngSubmit)="login()">
      <mat-form-field appearance="outline" (change)="storeEmail()" class="auth-form-field mt-15">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" placeholder="Enter your email" autocomplete="username" />
        @if (form.get('email')?.hasError('required')) {
        <mat-error>
          Email is required
        </mat-error>
        }
        @if (form.get('email')?.hasError('email')) {
        <mat-error>
          Invalid email address
        </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="auth-form-field">
        <mat-label>Password</mat-label>
        <input matInput formControlName="password" [type]="hide() ? 'password' : 'text'"
          placeholder="Enter your password" #passwordInput autocomplete="current-password" />
        <button mat-icon-button matSuffix (click)="hide.set(!hide())" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide()" type="button" class="mr-7" matTooltip="{{ hide() ? 'Show' : 'Hide' }} password">
          <mat-icon>{{ hide() ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        @if (form.get('password')?.hasError('required')) {
        <mat-error>
          Password is required
        </mat-error>
        }
        @if (form.get('password')?.hasError('minlength')) {
        <mat-error>
          Password must be at least {{ passwordMinLength }} characters
        </mat-error>
        }
      </mat-form-field>

      <button mat-flat-button class="main-button-squared-full-width lightyellow mb-25" type="submit" 
        [disabled]="form.invalid || loading() || !isUserLogInEnabled()">
        @if(!loading()) {
        <span>Continue</span>
        } @else {
        <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
        }
      </button>

    </form>

    <div class="bottom-actions">
      <button mat-button [routerLink]="['/signup']">
        Create account
      </button>

      <span class="separator">|</span>

      <button mat-button [routerLink]="['/reset-password']" [queryParams]="{ email: userEmail }">
        Reset password
      </button>
    </div>

    
  </div>


</div>

@if (!isMobile) {
  <div class="login-features">

    <div class="login-feature">
      <mat-icon>verified</mat-icon>
      <div class="title">Absolutely Free</div>
      <div class="subtitle">No fees forever</div>
    </div>

    <div class="login-feature">
      <mat-icon>local_shipping</mat-icon>
      <div class="title">RGN Load Board</div>
      <div class="subtitle">Post & Search</div>
    </div>

    <div class="login-feature">
      <mat-icon>api</mat-icon>
      <div class="title">With Free API</div>
      <div class="subtitle">Connect your TMS</div>
    </div>

  </div>
}

@if (isMobile) {
  <div class="login-mobile-info">

    <div class="features">

      <div class="feature">
        <mat-icon>check_circle</mat-icon>
        <span>Free</span>
      </div>

      <div class="feature">
        <mat-icon>check_circle</mat-icon>
        <span>Post</span>
      </div>

      <div class="feature">
        <mat-icon>check_circle</mat-icon>
        <span>Search</span>
      </div>

      <div class="feature">
        <mat-icon>check_circle</mat-icon>
        <span>API</span>
      </div>

    </div>

    <div class="tagline">
      The only RGN Load Board you’ll ever need.
    </div>

  </div>
}
